const Config = (function () {
    return {
        "REGION": "GLOBAL",
        "LANGUAGE": "en",
        "client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "client_id": "emvg3hk2tqu3q37fcw6cwyl4bi",  // v2 线上
        // "backend_host": "https://y5384v7heb.execute-api.us-east-1.amazonaws.com/prod",
        // "backend_host": "https://192.168.6.62:8084",
        // "backend_host": "https://bana6ys6sk.execute-api.us-east-1.amazonaws.com/prod",
        // "backend_host": "https://account.api.woankeji.cn", // v2 线下
        "backend_host": "https://account.api.switchbot.net",  // v2 线上
        // "mobile_management_backend_host": "https://core.us.api.woankeji.cn", // v2 线下
        "mobile_management_backend_host": "https://wonderlabs.us.api.switchbot.net/homepage", // v2 线上
        "wonder_backend_host": "https://wonderlabs.us.api.switchbot.net/wonder",

        "third_part_client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "amazon_client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "google_client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "apple_client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "error_code": {
            // 2024年5月20日16:06:39 新增 错误码
            2012: "This account is already signed up. If you have a SwitchBot account, please sign in.", // 这个有专门的接口，不做处理 账号已存在
            2024: "Password Error", // 这个有专门的接口返回后人机验证 密码错误次数过多（5 次）
            2030: "Please try to resend the verification code.",
            2033: "Please try to resend the verification code.", // 验证码连续 3 次输入错误，
            2035: "SMS verification code requests have reached the limit.", // 验证码下发已达上限
            2036: "用户从流程第一步重新开始",
            2007: "MFA token 错误",
            2034: "Human-computer verification failed",
            2050: "Too many requests. Try again later.",
            2402: "Repeatedly bind third-party accounts",
            2403: "The current three parties are bound by other switchbots",
            2042: "Bind third-party accounts repeatedly",
            2404: "Failed to obtain the third-party account info.",
            2040: "This Shopify account cannot be found",
            // -------end 新增 错误码
            2020: "Username or password is wrong",
            2010: "User does not exist",
            2011: "Email address not verified",
            2013: "This email address is your Google account. Please login with Google.",
            2014: "This email address is your Amazon account. Please login with Amazon.",
            2015: "This email address is your Apple id. Please login with Apple.",
            2031: "Verification code is wrong"
        }
    }
})()